export default __webpack_public_path__ + "_/shared_modules/base-layout/img/global_sprite-e30eeaf700ada0c57adfeeefeceda60d.png";